import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { Text, Dropdown } from 'components/base'
import { CheckMarkIcon } from 'components/Utils/Icons'
import TooltipOnHover from 'components/Utils/TooltipOnHover'
import { getListState } from 'data'
import {
  selectors as NotificationsSelectors,
  ALL_NOTIFICATIONS_LIST_NAME,
} from 'data/notifications'
import acknowledgeAllNotifications from 'components/Notifications/dataSync/acknowledgeAll'
import fetchesLastFiveNotifications from './dataSync/fetchesLastFiveNotifications'

import NotificationRow from 'screens/NotificationsRow/Row'
import emptyNotificationCenter from 'assets/images/empty-notification-center.svg'
import ModalLink from 'components/Utils/Modal/Link'
import { NOTIFICATIONS_CENTER } from 'components/Utils/Modal/constants'

export class NotificationCenterPopover extends Component {
  componentDidMount() {
    this.props.forceQuery()
  }

  render() {
    const {
      listState,
      notificationsIds,
      onClosePopover,
      acknowledgeAllNotifications,
    } = this.props

    const isLoading = listState.loading
    const isPristine = listState.pristine
    const isEmpty = listState.nodes.length === 0

    return (
      <Dropdown.Wrapper>
        <Dropdown.Body
          className="flexbox flexbox-column"
          style={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}
        >
          <Dropdown.Header className="flexbox flexbox-space-between flexbox-align-center border-shade-50 border-bottom-small">
            <Text.Name>Notifications</Text.Name>
            <Text.Action
              className="font-size-small flexbox flexbox-align-center"
              onClick={() => acknowledgeAllNotifications()}
            >
              <TooltipOnHover
                id="mark-all-as-read"
                tooltipContent="Mark all as read"
                placement="left"
              >
                <div className="background-shade-50-on-hover radius-normal padding-small">
                  <CheckMarkIcon size={16} className="green" />
                </div>
              </TooltipOnHover>
            </Text.Action>
          </Dropdown.Header>

          {!isPristine &&
            !isEmpty && (
              <Dropdown.Menu className="flexbox flexbox-grow flexbox-column">
                <div className="flexbox-grow scroll-y">
                  {notificationsIds.map(notificationId => (
                    <NotificationRow
                      key={notificationId}
                      notificationId={notificationId}
                      onNavigateExtra={onClosePopover}
                      className="padding-horizontal-medium"
                      closePopOver={onClosePopover}
                    />
                  ))}
                </div>

                <ModalLink
                  className="flexbox-no-grow border-shade-50 border-top-small"
                  to={NOTIFICATIONS_CENTER}
                >
                  <Dropdown.Button onClick={onClosePopover}>
                    See all notifications
                  </Dropdown.Button>
                </ModalLink>
              </Dropdown.Menu>
            )}

          {isEmpty &&
            !isPristine &&
            !isLoading && (
              <div className="background-shade-100 padding-top-larger padding-bottom-medium">
                <img
                  className="block margin-left-auto margin-right-auto"
                  src={emptyNotificationCenter}
                  alt="no notifications"
                  style={{ width: 128 }}
                />
                <div className="margin-top-large shade-10 font-weight-medium center-text">
                  No notifications
                </div>
              </div>
            )}
        </Dropdown.Body>
      </Dropdown.Wrapper>
    )
  }
}

export default compose(
  acknowledgeAllNotifications(),
  fetchesLastFiveNotifications(),
  connect(function mapStateToProps(state) {
    return {
      listState: getListState(ALL_NOTIFICATIONS_LIST_NAME)(state),
      notificationsIds: NotificationsSelectors.getLastNotificationIds(
        state,
        10
      ),
    }
  })
)(NotificationCenterPopover)
